/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { HierarchiesControllerGetAncestorsQueryResponse, HierarchiesControllerGetAncestorsPathParams, HierarchiesControllerGetAncestorsQueryParams, HierarchiesControllerGetAncestors401, HierarchiesControllerGetAncestors403 } from "../../models/hierarchiesController/HierarchiesControllerGetAncestors";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { hierarchiesControllerGetAncestors } from "../../clients/hierarchiesService/hierarchiesControllerGetAncestors";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const hierarchiesControllerGetAncestorsQueryKey = (scopeId: HierarchiesControllerGetAncestorsPathParams["scopeId"], params: HierarchiesControllerGetAncestorsQueryParams = {}) => [{
  url: '/api/v1/hierarchies/:scopeId/ancestors',
  params: {
    scopeId: scopeId
  }
}, ...(params ? [params] : [])] as const;
export type HierarchiesControllerGetAncestorsQueryKey = ReturnType<typeof hierarchiesControllerGetAncestorsQueryKey>;
export function hierarchiesControllerGetAncestorsQueryOptions(scopeId: HierarchiesControllerGetAncestorsPathParams["scopeId"], params?: HierarchiesControllerGetAncestorsQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = hierarchiesControllerGetAncestorsQueryKey(scopeId, params);
  return queryOptions<HierarchiesControllerGetAncestorsQueryResponse, ResponseErrorConfig<HierarchiesControllerGetAncestors401 | HierarchiesControllerGetAncestors403>, HierarchiesControllerGetAncestorsQueryResponse, typeof queryKey>({
    enabled: !!scopeId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return hierarchiesControllerGetAncestors(scopeId, params, config);
    }
  });
}

/**
 * @description Retrieve all parent scopes up to the root. Supports filtering by scope type(s) using comma-separated values (e.g., scopeType=FILE,FOLDER)
 * @summary Get ancestor scopes
 * {@link /api/v1/hierarchies/:scopeId/ancestors}
 */
export function useHierarchiesControllerGetAncestors<TData = HierarchiesControllerGetAncestorsQueryResponse, TQueryData = HierarchiesControllerGetAncestorsQueryResponse, TQueryKey extends QueryKey = HierarchiesControllerGetAncestorsQueryKey>(scopeId: HierarchiesControllerGetAncestorsPathParams["scopeId"], params?: HierarchiesControllerGetAncestorsQueryParams, options: {
  query?: Partial<QueryObserverOptions<HierarchiesControllerGetAncestorsQueryResponse, ResponseErrorConfig<HierarchiesControllerGetAncestors401 | HierarchiesControllerGetAncestors403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? hierarchiesControllerGetAncestorsQueryKey(scopeId, params);
  const query = useQuery({
    ...hierarchiesControllerGetAncestorsQueryOptions(scopeId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<HierarchiesControllerGetAncestors401 | HierarchiesControllerGetAncestors403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}